import { FormattedMessage } from 'react-intl'
import { useRouter } from 'solito/router'

import PartRequestsIcon from 'app/assets/icons/part-requests-icon.svg'
import Button, { ButtonProps } from 'app/components/base/Button'
import { SEARCH_LINK } from 'app/utils/constants/menu.constants'

interface PartRequestsButtonProps
  extends Pick<ButtonProps, 'sx' | 'fullWidth'> {}

const PartRequestsButton = ({ sx, fullWidth }: PartRequestsButtonProps) => {
  const { push } = useRouter()

  return (
    <Button
      variant="outlined"
      startIcon={<PartRequestsIcon />}
      onClick={() => push(`${SEARCH_LINK}?partRequest=true`)}
      size="small"
      fullWidth={fullWidth}
      sx={{
        maxWidth: fullWidth ? '100%' : 155,
        px: 1,
        backgroundColor: 'common.white',
        color: 'primary.main',
        '&:hover': { backgroundColor: 'common.white', opacity: 0.8 },
        ...sx
      }}
    >
      <FormattedMessage defaultMessage="Part Requests" />
    </Button>
  )
}

export default PartRequestsButton
